const { styled } = require('@mui/material');

export const StyledPermissions = styled('div')`
  .search {
    display: flex;
    justify-content: flex-end;
    margin: 12px 0;
    align-items: center;
    gap: 6px;
    .input-search {
      width: 300px;
    }
  }
`;

export const StyledSelectPermissions = styled('div')`
  display: flex;
  flex: 1;
  justify-content: center;
  .option-label {
    padding: 3px 0px;
  }
  .bold-option {
    font-weight: 700;
  }
`;
